/* JellyChic policy pages (/policies/*), with snippets/jc-policy.liquid.
   The policy is admin text: nothing here changes its words. It only gives the markup structure:
   - bold lines with a point size (or "1. …") become real h2/h3 headings with ids and a copy-link anchor
   - "– item" paragraphs become a list, emails become mailto links, emoji lines become contact rows
   - contents (sticky on desktop, a jump pill + sheet on phones), reading progress, "Jump to an answer" chips
   Without this file the policy still reads well (jc-policy.css styles the raw markup). */
(function () {
  'use strict';

  var root = document.querySelector('[data-jc-pol]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var body = root.querySelector('.shopify-policy__body .rte') || root.querySelector('.shopify-policy__body') || root.querySelector('[data-jc-pol-body]');
  if (!body) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function norm(t) { return (t || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
  function make(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }
  var SVG_DOWN = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 5v14M6 13l6 6 6-6"/></svg>';

  var EMO;
  try { EMO = new RegExp('^[\\s\\u200d\\ufe0f\\p{Extended_Pictographic}]+', 'u'); }
  catch (e) { EMO = /^(?:\s|‍|️|[←-⯿]|[\ud83c-\ud83e][\udc00-\udfff])+/; }
  function emojiOnly(t) { t = norm(t); return !!t && t.replace(EMO, '') === ''; }

  /* ---------- 1. Tidy the admin markup ---------- */

  // Empty spacer paragraphs (" ", <br>)
  $$('p', body).forEach(function (p) {
    if (!norm(p.textContent) && !p.querySelector('img, iframe, video, table, svg')) p.remove();
  });

  // The policy often repeats its own title as the first line: the band already shows it
  var titleEl = $('.jc-pol__title');
  var title = norm(titleEl ? titleEl.textContent : '').toLowerCase();
  var first = body.firstElementChild;
  if (first && /^(P|H[1-6])$/.test(first.tagName) && norm(first.textContent).toLowerCase() === title) first.hidden = true;

  // Links into the Shopify admin only work for the owner: keep the words, drop the link
  $$('a[href*="admin.shopify.com"], a[href*=".myshopify.com/admin"]', body).forEach(function (a) {
    while (a.firstChild) a.parentNode.insertBefore(a.firstChild, a);
    a.remove();
  });

  /* ---------- 2. Headings ---------- */

  function isBold(el, stop) {
    while (el && el !== stop) {
      if (/^(B|STRONG)$/.test(el.tagName)) return true;
      var fw = el.style && el.style.fontWeight;
      if (fw && (/bold/.test(fw) || parseInt(fw, 10) >= 600)) return true;
      el = el.parentElement;
    }
    return false;
  }
  function boldOnly(p) {
    var w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
    var n, any = false;
    while ((n = w.nextNode())) {
      if (!norm(n.nodeValue)) continue;
      if (isBold(n.parentElement, p)) { any = true; continue; }
      if (emojiOnly(n.nodeValue)) continue;
      return false;
    }
    return any;
  }
  function sizePx(v) {
    var m = /([\d.]+)\s*(pt|px|em|rem)/.exec(v || '');
    if (!m) return 0;
    var n = parseFloat(m[1]);
    return m[2] === 'pt' ? n * 4 / 3 : (m[2] === 'px' ? n : n * 16);
  }
  function biggest(p) {
    var max = sizePx(p.style && p.style.fontSize);
    $$('[style]', p).forEach(function (el) { max = Math.max(max, sizePx(el.style.fontSize)); });
    return max;
  }

  var used = {};
  function slugify(t) {
    var s = t.toLowerCase();
    if (s.normalize) s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    s = s.replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 64) || 'section';
    var id = s, i = 2;
    while (used[id] || document.getElementById(id)) id = s + '-' + i++;
    used[id] = true;
    return id;
  }

  var native = $$('h1, h2, h3, h4, h5, h6', body).filter(function (h) { return !h.hidden; });
  var minTag = native.reduce(function (m, h) { return Math.min(m, +h.tagName[1]); }, 7);

  var heads = [];
  $$('p, h1, h2, h3, h4, h5, h6', body).forEach(function (el) {
    if (el.hidden || el.closest('li, table, blockquote')) return;
    var text = norm(el.textContent);
    if (!text || text.length > 140) return;
    var level = 0;
    if (/^H\d$/.test(el.tagName)) {
      level = +el.tagName[1] === minTag ? 2 : 3;
    } else if (boldOnly(el)) {
      if (biggest(el) >= 17 || /^\d{1,2}[.)]\s+\S/.test(text)) level = 2;
      else if (/^[a-z][.)]\s+\S/i.test(text) || /:$/.test(text)) level = 3;
    }
    if (!level) return;

    var m = /^(\d{1,2})[.)]\s+(.+)$/.exec(text);
    var num = m && level === 2 ? m[1] : '';
    var label = norm((num ? m[2] : text).replace(EMO, ''));
    if (!label) return;

    var h = make(level === 2 ? 'h2' : 'h3', 'jc-pol__h jc-pol__h' + level);
    h.id = slugify(label);
    h.tabIndex = -1;
    if (num) h.appendChild(make('span', 'jc-pol__n', pad(num)));
    h.appendChild(make('span', 'jc-pol__ht', label));
    if (level === 2) {
      var a = make('a', 'jc-pol__anchor', '#');
      a.href = '#' + h.id;
      a.setAttribute('aria-label', 'Copy link to “' + label + '”');
      h.appendChild(a);
    }
    el.replaceWith(h);
    heads.push({ el: h, id: h.id, label: label, num: num, level: level });
  });

  /* ---------- 3. Lists, links, rows ---------- */

  // "– item" paragraphs → a real list (the dash goes, the words stay)
  var DASH = /^\s*[–—•·\-]\s+/;
  function stripLead(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (!norm(n.nodeValue)) continue;
      n.nodeValue = n.nodeValue.replace(DASH, '');
      return;
    }
  }
  var list = null;
  Array.prototype.slice.call(body.children).forEach(function (el) {
    if (el.tagName === 'P' && !el.hidden && DASH.test(el.textContent.replace(/ /g, ' '))) {
      if (!list) { list = make('ul', 'jc-pol__list'); el.before(list); }
      var li = document.createElement('li');
      stripLead(el);
      while (el.firstChild) li.appendChild(el.firstChild);
      list.appendChild(li);
      el.remove();
    } else {
      list = null;
    }
  });

  // Emails → mailto links (an address split across several spans still counts)
  var EMAIL_ONLY = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  function mailto(addr) {
    var a = make('a', 'jc-pol__mailto', addr);
    a.href = 'mailto:' + addr;
    return a;
  }
  $$('strong, b, span', body).forEach(function (el) {
    if (!el.isConnected || el.closest('a') || el.closest('.jc-pol__h')) return;
    var t = norm(el.textContent);
    if (!EMAIL_ONLY.test(t)) return;
    el.textContent = '';
    el.appendChild(mailto(t));
  });
  var EMAIL = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi;
  var TODO = /\[(?:insert|add|your|enter)[^\]]*\]/gi;
  (function () {
    var w = document.createTreeWalker(body, NodeFilter.SHOW_TEXT), n, hits = [];
    while ((n = w.nextNode())) {
      if (n.parentElement.closest('a, .jc-pol__h')) continue;
      EMAIL.lastIndex = 0; TODO.lastIndex = 0;
      if (EMAIL.test(n.nodeValue) || TODO.test(n.nodeValue)) hits.push(n);
    }
    hits.forEach(function (node) {
      var s = node.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      var re = /([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})|(\[(?:insert|add|your|enter)[^\]]*\])/gi;
      while ((m = re.exec(s))) {
        if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
        if (m[1]) frag.appendChild(mailto(m[1]));
        else {
          var mk = make('mark', 'jc-pol__todo', m[2]);
          mk.title = 'Placeholder left in the policy text: fix it in Settings → Policies';
          frag.appendChild(mk);
        }
        last = re.lastIndex;
      }
      if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
      node.replaceWith(frag);
    });
  })();

  // Emoji lines ("📧 Email: …") → contact rows
  $$('p, li', body).forEach(function (p) {
    var w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (!norm(n.nodeValue)) continue;
      var m = EMO.exec(n.nodeValue);
      if (!m || !norm(m[0])) return;
      var emo = make('span', 'jc-pol__emo', norm(m[0]));
      emo.setAttribute('aria-hidden', 'true');
      n.nodeValue = n.nodeValue.slice(m[0].length);
      p.insertBefore(emo, p.firstChild);
      if (n.parentElement !== p && !norm(n.parentElement.textContent)) n.parentElement.remove();
      p.classList.add('jc-pol__row');
      var rest = make('span');
      while (emo.nextSibling) rest.appendChild(emo.nextSibling);
      p.appendChild(rest);
      return;
    }
  });

  // The phrases the policy put in bold inside a sentence get a light highlighter
  $$('strong, b', body).forEach(function (el) {
    if (el.closest('.jc-pol__h') || el.querySelector('a, .jc-pol__todo') || el.closest('a')) return;
    if (el.parentElement.closest('strong, b')) return;
    var block = el.closest('p, li');
    if (!block) return;
    var t = norm(el.textContent);
    if (!t || t.length > 70 || /:$/.test(t)) return;
    if (norm(block.textContent) === t) return;
    el.classList.add('jc-pol__em');
  });

  // The first paragraph reads as the intro
  var firstP = Array.prototype.slice.call(body.children).filter(function (el) { return !el.hidden; })[0];
  if (firstP && firstP.tagName === 'P' && norm(firstP.textContent).length > 80) firstP.classList.add('jc-pol__intro');

  // Wide tables scroll inside the column
  $$('table', body).forEach(function (t) {
    var wrap = make('div', 'jc-pol__scroll');
    t.before(wrap);
    wrap.appendChild(t);
  });

  /* ---------- 4. Contents, chips, meta ---------- */

  var tops = heads.filter(function (h) { return h.level === 2; });
  if (tops.length < 2) tops = heads.slice();
  var hasToc = tops.length >= 3;

  var count = $('[data-jc-pol-count]');
  if (count && tops.length >= 2) {
    count.textContent = tops.length + ' sections';
    count.hidden = false;
  }

  var tocLinks = [], sheetLinks = [];
  if (hasToc) {
    var tocList = $('[data-jc-pol-toc-list]'), sheetList = $('[data-jc-pol-sheet-list]');
    tops.forEach(function (h, i) {
      var n = h.num ? pad(h.num) : pad(i + 1);
      var a = make('a', 'jc-pol__toc-link');
      a.href = '#' + h.id;
      a.appendChild(make('span', 'jc-pol__toc-n', n));
      a.appendChild(make('span', '', h.label));
      var li = document.createElement('li');
      li.appendChild(a);
      tocList.appendChild(li);
      tocLinks.push(a);

      var b = make('a');
      b.href = '#' + h.id;
      b.appendChild(make('span', 'jc-pol__sheet-n', n));
      b.appendChild(make('span', '', h.label));
      var li2 = document.createElement('li');
      li2.appendChild(b);
      sheetList.appendChild(li2);
      sheetLinks.push(b);
    });
    $('[data-jc-pol-toc]').hidden = false;
    $('[data-jc-pol-grid]').classList.add('has-toc');
    $('[data-jc-pol-jump]').hidden = false;
  } else {
    // the snippet reserved the desktop column for a long policy; without 3 headings it goes back to one column
    $('[data-jc-pol-toc]').hidden = true;
    $('[data-jc-pol-grid]').classList.remove('has-toc');
  }

  var qs = [];
  try { qs = JSON.parse(($('[data-jc-pol-questions]') || {}).textContent || '[]'); } catch (e) { qs = []; }
  // The chips are already on the page (snippets/jc-policy.liquid, one per question, in order): point each at the
  // heading its words find, drop the ones the policy has no heading for.
  var made = 0, seen = {};
  $$('[data-jc-pol-chip]').forEach(function (a) {
    var q = qs[parseInt(a.getAttribute('data-jc-pol-chip'), 10)], li = a.closest('li') || a, re, hit = null;
    if (q && q.m) { try { re = new RegExp(q.m, 'i'); } catch (e) { re = null; } }
    if (re) for (var i = 0; i < tops.length; i++) { if (re.test(tops[i].label)) { hit = tops[i]; break; } }
    if (!q || !hit || seen[q.q]) { li.remove(); return; }
    seen[q.q] = true;
    a.href = '#' + hit.id;
    made++;
  });
  if (made < 2) $('[data-jc-pol-ask]').hidden = true;

  /* ---------- 4b. Search this policy (in-app browsers have no find-in-page) ---------- */

  // Sections: each top heading and what follows it; the words before the first heading are the introduction
  var sections = [];
  (function () {
    var cur = { id: 'jc-pol-text', label: 'Introduction', num: '', els: [] };
    var topEls = tops.map(function (h) { return h.el; });
    Array.prototype.slice.call(body.children).forEach(function (el) {
      var i = topEls.indexOf(el);
      if (i !== -1) {
        if (cur.els.length) sections.push(cur);
        cur = { id: tops[i].id, label: tops[i].label, num: tops[i].num, els: [] };
      } else if (!el.hidden) {
        cur.els.push(el);
      }
    });
    if (cur.els.length) sections.push(cur);
    // Lists and rows read as separate phrases, not run together
    function textOf(el) {
      if (/^(UL|OL|TABLE|TBODY|TR|DIV)$/.test(el.tagName)) return Array.prototype.slice.call(el.children).map(textOf).join(' ');
      return el.textContent;
    }
    sections.forEach(function (sec) { sec.text = norm(sec.els.map(textOf).join(' ')); });
  })();

  var hits = [];
  function clearHits() {
    hits.forEach(function (m) {
      var parent = m.parentNode;
      if (!parent) return;
      parent.replaceChild(document.createTextNode(m.textContent), m);
      parent.normalize();
    });
    hits = [];
  }
  function markHits(sec, q) {
    clearHits();
    if (!sec || !q) return;
    var ql = q.toLowerCase();
    sec.els.forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, nodes = [];
      while ((n = w.nextNode())) { if (n.nodeValue.toLowerCase().indexOf(ql) !== -1) nodes.push(n); }
      nodes.forEach(function (node) {
        var s = node.nodeValue, low = s.toLowerCase(), frag = document.createDocumentFragment(), last = 0, i;
        while ((i = low.indexOf(ql, last)) !== -1) {
          if (i > last) frag.appendChild(document.createTextNode(s.slice(last, i)));
          var m = make('mark', 'jc-pol__hit', s.slice(i, i + ql.length));
          frag.appendChild(m);
          hits.push(m);
          last = i + ql.length;
        }
        if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
        node.replaceWith(frag);
      });
    });
  }

  function search(q) {
    var ql = norm(q).toLowerCase();
    if (ql.length < 2) return null;
    var out = [];
    sections.forEach(function (sec) {
      var low = sec.text.toLowerCase(), i = low.indexOf(ql), n = 0, j = i;
      while (j !== -1) { n++; j = low.indexOf(ql, j + ql.length); }
      var inHead = sec.label.toLowerCase().indexOf(ql) !== -1;
      if (!n && !inHead) return;
      out.push({ sec: sec, n: n, i: i });
    });
    return out;
  }

  var contactHref = ($('.jc-pol__cta .jc-btn') || {}).href || '';
  function renderResults(box, q) {
    box.textContent = '';
    var res = search(q);
    if (!res) return;
    var ql = norm(q);
    var sum = make('p', 'jc-pol__res-sum');
    if (!res.length) {
      sum.textContent = 'Nothing for “' + ql + '” in this policy. ';
      if (contactHref) {
        var ask = make('a', '', 'Ask us instead');
        ask.href = contactHref;
        sum.appendChild(ask);
      }
      box.appendChild(sum);
      return;
    }
    sum.textContent = res.length === 1 ? 'Found in 1 section' : 'Found in ' + res.length + ' sections';
    box.appendChild(sum);
    var ol = make('ol', 'jc-pol__res-list');
    ol.setAttribute('role', 'list');
    res.slice(0, 8).forEach(function (r) {
      var a = make('a', 'jc-pol__res');
      a.href = '#' + r.sec.id;
      a.dataset.q = ql;
      var t = make('span', 'jc-pol__res-t');
      if (r.sec.num) t.appendChild(make('span', 'jc-pol__res-n', '§ ' + pad(r.sec.num)));
      t.appendChild(document.createTextNode(r.sec.label));
      a.appendChild(t);
      if (r.i !== -1) {
        var txt = r.sec.text, from = Math.max(0, r.i - 42), to = Math.min(txt.length, r.i + ql.length + 64);
        var sn = make('span', 'jc-pol__res-s');
        sn.appendChild(document.createTextNode((from ? '…' : '') + txt.slice(from, r.i)));
        sn.appendChild(make('mark', '', txt.slice(r.i, r.i + ql.length)));
        sn.appendChild(document.createTextNode(txt.slice(r.i + ql.length, to) + (to < txt.length ? '…' : '')));
        a.appendChild(sn);
      }
      if (r.n > 1) a.appendChild(make('span', 'jc-pol__res-c', r.n + ' mentions'));
      var li = document.createElement('li');
      li.appendChild(a);
      ol.appendChild(li);
    });
    box.appendChild(ol);
  }

  var sheetEl = $('[data-jc-pol-sheet]');
  if (tops.length >= 3 && sections.length) {
    $$('[data-jc-pol-search]').forEach(function (form) {
      var input = $('[data-jc-pol-q]', form);
      var box = form.nextElementSibling && form.nextElementSibling.hasAttribute('data-jc-pol-results') ? form.nextElementSibling : null;
      if (!input || !box) return;
      box.setAttribute('aria-live', 'polite');
      var inSheet = sheetEl && sheetEl.contains(form), t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          renderResults(box, input.value);
          if (inSheet) sheetEl.classList.toggle('is-searching', norm(input.value).length >= 2);
          if (!norm(input.value)) clearHits();
        }, 160);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(t);
        renderResults(box, input.value);
        var firstRes = box.querySelector('.jc-pol__res');
        if (firstRes) firstRes.click();
      });
    });
    var findEl = $('[data-jc-pol-find]');
    if (findEl) findEl.hidden = false;
    $('[data-jc-pol-quick]').hidden = false;
  } else {
    $$('.jc-pol__search--sheet').forEach(function (f) { f.hidden = true; });
    var findNone = $('[data-jc-pol-find]');
    if (findNone) findNone.hidden = true;   // drawn by the snippet; nothing to search here
  }
  // The quick box is drawn for script-on visitors; empty (no short version, no search, no chips) it goes
  var quick = $('[data-jc-pol-quick]');
  if (quick && !quick.querySelector('.jc-pol__short, [data-jc-pol-find]:not([hidden]), [data-jc-pol-ask]:not([hidden])')) quick.hidden = true;

  /* ---------- 5. Moving around ---------- */

  var toastEl = $('[data-jc-pol-toast]'), toastT;
  function toast(t) {
    if (!toastEl) return;
    toastEl.textContent = t;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }
  function behaviour() { return reduce.matches ? 'auto' : 'smooth'; }
  function flash(h) {
    h.classList.remove('is-flash');
    void h.offsetWidth;
    h.classList.add('is-flash');
    setTimeout(function () { h.classList.remove('is-flash'); }, 1700);
  }
  function go(id, instant) {
    var h = document.getElementById(id);
    if (!h) return;
    h.scrollIntoView({ behavior: instant ? 'auto' : behaviour(), block: 'start' });
    try { history.replaceState(null, '', '#' + id); } catch (e) { /* file:// or sandbox */ }
    h.focus({ preventScroll: true });
    flash(h);
  }

  var sheet = $('[data-jc-pol-sheet]'), opener = $('[data-jc-pol-open]');
  function openSheet() {
    if (!sheet) return;
    if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
    document.documentElement.classList.add('jc-pol-lock');
    var cur = sheet.querySelector('[aria-current]') || sheet.querySelector('.jc-pol__sheet-list a');
    if (cur) { cur.focus(); cur.scrollIntoView({ block: 'center' }); }
  }
  function closeSheet(keepFocus) {
    if (!sheet || !sheet.hasAttribute('open')) return;
    if (typeof sheet.close === 'function') sheet.close(); else sheet.removeAttribute('open');
    document.documentElement.classList.remove('jc-pol-lock');
    if (keepFocus && opener) opener.focus();
  }
  if (opener) opener.addEventListener('click', openSheet);
  if (sheet) {
    sheet.addEventListener('close', function () { document.documentElement.classList.remove('jc-pol-lock'); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(true); });
    $$('[data-jc-pol-close]', sheet).forEach(function (b) { b.addEventListener('click', function () { closeSheet(true); }); });
  }

  function copyLink(id) {
    var url = location.href.split('#')[0] + '#' + id;
    try { history.replaceState(null, '', '#' + id); } catch (e) { /* ignore */ }
    var done = function () { toast('Link copied'); };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done, function () { toast('Link is in the address bar'); });
    } else {
      toast('Link is in the address bar');
    }
  }

  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || !root.contains(a)) return;
    if (a.hasAttribute('data-jc-pol-top')) {
      e.preventDefault();
      closeSheet();
      window.scrollTo({ top: 0, behavior: behaviour() });
      try { history.replaceState(null, '', location.pathname + location.search); } catch (err) { /* ignore */ }
      if (titleEl) { titleEl.tabIndex = -1; titleEl.focus({ preventScroll: true }); }
      return;
    }
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target || !(body.contains(target) || target.contains(body))) return;
    e.preventDefault();
    if (a.classList.contains('jc-pol__anchor')) { copyLink(id); return; }
    closeSheet();
    if (a.classList.contains('jc-pol__res') && a.dataset.q) {
      var sec = sections.filter(function (x) { return x.id === id; })[0];
      markHits(sec, a.dataset.q);
      if (hits.length && id === 'jc-pol-text') { hits[0].scrollIntoView({ behavior: behaviour(), block: 'center' }); return; }
    }
    go(id);
  });

  // Phones: the switcher scrolls sideways; start it with this policy in view
  var pills = $('.jc-pol__pills'), here = $('.jc-pol__pill[aria-current="page"]');
  if (pills && here && pills.scrollWidth > pills.clientWidth) {
    pills.scrollLeft = Math.max(0, here.parentElement.offsetLeft - (pills.clientWidth - here.offsetWidth) / 2);
  }

  $$('[data-jc-pol-print]').forEach(function (b) {
    b.hidden = false;
    b.addEventListener('click', function () { window.print(); });
  });

  var bag = $('[data-jc-pol-bag]');
  if (bag) {
    bag.addEventListener('click', function () {
      if (reduce.matches) return;
      bag.classList.remove('is-squish');
      void bag.offsetWidth;
      bag.classList.add('is-squish');
    });
    bag.addEventListener('animationend', function (e) { if (e.animationName === 'jc-pol-squish') bag.classList.remove('is-squish'); });
  }

  /* ---------- 6. Reading position: cached offsets, one rAF per scroll ---------- */

  var doc = $('[data-jc-pol-doc]'), end = $('[data-jc-pol-end]');
  var rail = $('[data-jc-pol-rail]'), pct = $('[data-jc-pol-pct]'), ring = $('[data-jc-pol-ring]');
  var jump = $('[data-jc-pol-jump]'), jumpK = $('[data-jc-pol-jump-k]'), jumpT = $('[data-jc-pol-jump-t]');
  var header = document.querySelector('.section-header') || document.querySelector('sticky-header') ||
    Array.prototype.slice.call(document.querySelectorAll('.shopify-section-group-header-group')).pop();
  var pos = { heads: [], docTop: 0, docH: 1, endTop: 0 };
  var state = { idx: -2, pct: -1, on: null, top: -1 };

  function measure() {
    var y = window.scrollY;
    pos.heads = tops.map(function (h) { return h.el.getBoundingClientRect().top + y; });
    var r = doc.getBoundingClientRect();
    pos.docTop = r.top + y;
    pos.docH = Math.max(1, r.height);
    pos.endTop = end ? end.getBoundingClientRect().top + y : Infinity;
  }

  function update() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight;
    var hb = 0;
    if (header) {
      var hr = header.getBoundingClientRect();
      hb = Math.max(0, Math.min(hr.bottom, 200));
    }

    var line = y + Math.max(hb, 0) + vh * 0.28;
    var idx = -1;
    for (var i = 0; i < pos.heads.length; i++) { if (pos.heads[i] <= line) idx = i; else break; }
    var p = (y + vh * 0.3 - pos.docTop) / Math.max(1, pos.docH - vh * 0.3);
    p = Math.min(1, Math.max(0, p));
    var on = hasToc && pos.heads.length > 0 && y + vh * 0.55 > pos.heads[0] && pos.endTop > y + vh - 40;

    if (Math.round(hb) !== state.top) {
      state.top = Math.round(hb);
      root.style.setProperty('--jc-pol-top', state.top + 'px');
    }
    if (rail) rail.style.transform = 'scaleY(' + p.toFixed(4) + ')';
    if (ring) ring.style.strokeDashoffset = String(100 - p * 100);
    var r = Math.round(p * 100);
    if (pct && r !== state.pct) { state.pct = r; pct.textContent = r + '% read'; }
    if (idx !== state.idx) {
      state.idx = idx;
      tocLinks.forEach(function (a, i) { if (i === idx) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
      sheetLinks.forEach(function (a, i) { if (i === idx) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
      if (jumpK && jumpT) {
        if (idx < 0) { jumpK.textContent = 'In this policy · ' + tops.length + ' sections'; jumpT.textContent = titleEl ? norm(titleEl.textContent) : ''; }
        else { jumpK.textContent = pad(idx + 1) + ' of ' + pad(tops.length); jumpT.textContent = tops[idx].label; }
        if (opener) opener.setAttribute('aria-label', 'Contents: ' + (idx < 0 ? tops.length + ' sections' : 'section ' + (idx + 1) + ' of ' + tops.length + ', ' + tops[idx].label));
      }
    }
    if (jump && on !== state.on) { state.on = on; jump.classList.toggle('is-on', on); }
  }

  var ticking = false, settle;
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
    // The header slides in after the scroll that revealed it: look again once it has settled
    clearTimeout(settle);
    settle = setTimeout(function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, 320);
  }
  function remeasure() { measure(); onScroll(); }

  measure();
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', remeasure);
  if (window.ResizeObserver) new ResizeObserver(remeasure).observe(doc);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
  window.addEventListener('load', remeasure);

  // Arriving with #section (a shared link): the ids exist only now
  if (location.hash.length > 1) {
    var target = null;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) { target = null; }
    if (target && body.contains(target)) requestAnimationFrame(function () { go(target.id, true); });
  }

  root.classList.add('is-ready');
})();
